// Content dropdown choices (landing, banner, TNC, email, push, contact us).
// Split from constants.js — edit here, not the composer.

import { BANNER_ACTION, BANNER_PRODUCT_PARENT, BANNER_TYPE } from '../Sections/banner'
import { STATUS } from '../Sections/core'
import { BOOLEAN_CHOICES, CATEGORY, GENERAL, GLOBAL, MOBILE, PRODUCT, WEB, WECHAT_MP } from '../Sections/internal'
import { LANDING_ACTION, LANDING_ACTION_PARAMETER, LANDING_ITEM_TYPE, LANDING_SECTION_ACTION, LANDING_SECTION_SECTION_TYPE, LANDING_SECTION_SERVICE_TYPE } from '../Sections/landing'
import { CONTACT_US_MESSAGE_TYPE, EMAIL_TEMPLATE_TYPE, TNC_TYPE } from '../Sections/types'

export const contentChoices = {
    TNC: {
        TYPE: [
            { value: TNC_TYPE.BANQUET, name: TNC_TYPE.BANQUET },
            { value: TNC_TYPE.BEAUTY_RESERVE, name: TNC_TYPE.BEAUTY_RESERVE },
            { value: TNC_TYPE.BEAUTY_RES_CHARGE, name: TNC_TYPE.BEAUTY_RES_CHARGE },
            { value: TNC_TYPE.H5_TAKEAWAY, name: TNC_TYPE.H5_TAKEAWAY },
            { value: TNC_TYPE.H5_TAK_CHARGE, name: TNC_TYPE.H5_TAK_CHARGE },
            { value: TNC_TYPE.MASK_CHECKIN, name: TNC_TYPE.MASK_CHECKIN },
            {
                value: TNC_TYPE.MERCHANT_TICKET_TEMPLATE,
                name: TNC_TYPE.MERCHANT_TICKET_TEMPLATE,
            },
            { value: TNC_TYPE.PRODUCT_TEMPLATE, name: TNC_TYPE.PRODUCT_TEMPLATE },
            {
                value: TNC_TYPE.PRODUCT_TEMPLATE_ECOUPON,
                name: TNC_TYPE.PRODUCT_TEMPLATE_ECOUPON,
            },
            {
                value: TNC_TYPE.PRODUCT_TEMPLATE_PRODUCT,
                name: TNC_TYPE.PRODUCT_TEMPLATE_PRODUCT,
            },
            {
                value: TNC_TYPE.PRODUCT_TEMPLATE_PUSH_MESSAGE,
                name: TNC_TYPE.PRODUCT_TEMPLATE_PUSH_MESSAGE,
            },
            {
                value: TNC_TYPE.PRODUCT_TEMPLATE_VALUE_UP_ECOUPON,
                name: TNC_TYPE.PRODUCT_TEMPLATE_VALUE_UP_ECOUPON,
            },
            {
                value: TNC_TYPE.PRODUCT_TEMPLATE_VALUE_UP_ECOUPON_OLD,
                name: TNC_TYPE.PRODUCT_TEMPLATE_VALUE_UP_ECOUPON_OLD,
            },
            { value: TNC_TYPE.RESERVE, name: TNC_TYPE.RESERVE },
            { value: TNC_TYPE.RESERVE2, name: TNC_TYPE.RESERVE2 },
            { value: TNC_TYPE.RESERVE_D, name: TNC_TYPE.RESERVE_D },
            { value: TNC_TYPE.RES_CHARGE, name: TNC_TYPE.RES_CHARGE },
            { value: TNC_TYPE.TAKEAWAY, name: TNC_TYPE.TAKEAWAY },
            { value: TNC_TYPE.TAKEAWAY_MESSAGE, name: TNC_TYPE.TAKEAWAY_MESSAGE },
            { value: TNC_TYPE.TAK_CHARGE, name: TNC_TYPE.TAK_CHARGE },
            { value: TNC_TYPE.TICKET, name: TNC_TYPE.TICKET },
            { value: TNC_TYPE.TICKET2, name: TNC_TYPE.TICKET2 },
            { value: TNC_TYPE.TICKET_D, name: TNC_TYPE.TICKET_D },
            {
                value: TNC_TYPE.TICKET_LEFT_REMIND,
                name: TNC_TYPE.TICKET_LEFT_REMIND,
            },
            { value: TNC_TYPE.TICKET_NOW, name: TNC_TYPE.TICKET_NOW },
            { value: TNC_TYPE.TICKET_WEB, name: TNC_TYPE.TICKET_WEB },
            { value: TNC_TYPE.TIC_CFM_1, name: TNC_TYPE.TIC_CFM_1 },
            { value: TNC_TYPE.TIC_CFM_FIN, name: TNC_TYPE.TIC_CFM_FIN },
            { value: TNC_TYPE.TIC_CHECKIN, name: TNC_TYPE.TIC_CHECKIN },
            {
                value: TNC_TYPE.TIC_CHECKIN_INVITEE,
                name: TNC_TYPE.TIC_CHECKIN_INVITEE,
            },
            { value: TNC_TYPE.TIC_INACT, name: TNC_TYPE.TIC_INACT },
            {
                value: TNC_TYPE.TMID_ECOUPON_FIRST,
                name: TNC_TYPE.TMID_ECOUPON_FIRST,
            },
            {
                value: TNC_TYPE.TMID_ECOUPON_REMARK,
                name: TNC_TYPE.TMID_ECOUPON_REMARK,
            },
            { value: TNC_TYPE.WEB, name: TNC_TYPE.WEB },
            { value: TNC_TYPE.TICKET_NO_SHOW, name: TNC_TYPE.TICKET_NO_SHOW },
        ],
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'D', name: { key: 'deactive' } },
            { value: 'P', name: { key: 'pending' } },
        ],
    },
    EMAIL_TEMPLATE: {
        TYPE: [
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_CREATE_ACCOUNT_APPROVAL,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_CREATE_ACCOUNT_APPROVAL,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_FORGOT_PASSWORD,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_FORGOT_PASSWORD,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_SALES_CONTRACT_TEST,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_SALES_CONTRACT_TEST,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_SET_PASSWORD,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_SET_PASSWORD,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_VERIFICATION,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_EMAIL_VERIFICATION,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_HSBC_CREATE_SHOP_NOTIFY,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_HSBC_CREATE_SHOP_NOTIFY,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_HSBC_EMAIL_VERIFICATION,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_HSBC_EMAIL_VERIFICATION,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_PUBLISH_PRODUCT_PASSCODE,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_PUBLISH_PRODUCT_PASSCODE,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.MERCHANT_YEDPAY_REGISTRAION,
                name: EMAIL_TEMPLATE_TYPE.MERCHANT_YEDPAY_REGISTRAION,
            },
            { value: EMAIL_TEMPLATE_TYPE.MX_API, name: EMAIL_TEMPLATE_TYPE.MX_API },
            {
                value: EMAIL_TEMPLATE_TYPE.PRODUCT_TRN_REC,
                name: EMAIL_TEMPLATE_TYPE.PRODUCT_TRN_REC,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.QUEUE_TICKET,
                name: EMAIL_TEMPLATE_TYPE.QUEUE_TICKET,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.RESERVATION_TICKET,
                name: EMAIL_TEMPLATE_TYPE.RESERVATION_TICKET,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.RESET_PASSWORD,
                name: EMAIL_TEMPLATE_TYPE.RESET_PASSWORD,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.RSV_TRN_REC,
                name: EMAIL_TEMPLATE_TYPE.RSV_TRN_REC,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.RSV_UPDATE_NOTIFY,
                name: EMAIL_TEMPLATE_TYPE.RSV_UPDATE_NOTIFY,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.SELF_REGISTER,
                name: EMAIL_TEMPLATE_TYPE.SELF_REGISTER,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.SELF_REGISTER_NOTIFY,
                name: EMAIL_TEMPLATE_TYPE.SELF_REGISTER_NOTIFY,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.TAKEAWAY_ACCEPT,
                name: EMAIL_TEMPLATE_TYPE.TAKEAWAY_ACCEPT,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.TAKEAWAY_ITEM,
                name: EMAIL_TEMPLATE_TYPE.TAKEAWAY_ITEM,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.TAKEAWAY_REJECT,
                name: EMAIL_TEMPLATE_TYPE.TAKEAWAY_REJECT,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.TAKEAWAY_SUBMIT,
                name: EMAIL_TEMPLATE_TYPE.TAKEAWAY_SUBMIT,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.TKY_TRN_REC,
                name: EMAIL_TEMPLATE_TYPE.TKY_TRN_REC,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.RACK_PRODUCT_ORDER,
                name: EMAIL_TEMPLATE_TYPE.RACK_PRODUCT_ORDER,
            },
            {
                value: EMAIL_TEMPLATE_TYPE.EVENT_OTP,
                name: EMAIL_TEMPLATE_TYPE.EVENT_OTP,
            }
        ],
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'D', name: { key: 'deactive' } },
            { value: 'P', name: { key: 'pending' } },
        ],
    },
    PUSH: {
        ACTION_TYPE: [
            { value: BANNER_ACTION.WEB_VIEW, name: BANNER_ACTION.WEB_VIEW },
            { value: BANNER_ACTION.LINK, name: BANNER_ACTION.LINK },
            { value: BANNER_ACTION.VIDEO, name: BANNER_ACTION.VIDEO },
            { value: BANNER_ACTION.PRODUCT, name: BANNER_ACTION.PRODUCT },
            {
                value: BANNER_ACTION.PRODUCT_CATEGORY,
                name: BANNER_ACTION.PRODUCT_CATEGORY,
            },
            {
                value: BANNER_ACTION.PRODUCT_BRAND,
                name: BANNER_ACTION.PRODUCT_BRAND,
            },
            { value: BANNER_ACTION.E_COUPON, name: BANNER_ACTION.E_COUPON },
            {
                value: BANNER_ACTION.E_COUPON_CATEGORY,
                name: BANNER_ACTION.E_COUPON_CATEGORY,
            },
            {
                value: BANNER_ACTION.E_COUPON_BRAND,
                name: BANNER_ACTION.E_COUPON_BRAND,
            },
            //{ value: BANNER_ACTION.CATEGORY_PRODUCT, name: BANNER_ACTION.CATEGORY_PRODUCT },
            //{ value: BANNER_ACTION.BRAND_PRODUCT, name: BANNER_ACTION.BRAND_PRODUCT },
            { value: BANNER_ACTION.FOLDER, name: BANNER_ACTION.FOLDER },
            { value: BANNER_ACTION.RESTAURANT, name: BANNER_ACTION.RESTAURANT },
            { value: BANNER_ACTION.SEARCH, name: BANNER_ACTION.SEARCH },
        ],
        STATUS: [
            { value: 'draft', name: { resource: 'Push', key: 'draft' } },
            { value: 'scheduled', name: { resource: 'Push', key: 'scheduled' } },
            { value: 'sending', name: { resource: 'Push', key: 'sending' } },
            { value: 'finished', name: { resource: 'Push', key: 'finished' } },
        ],
        TO_NOTIF: [...BOOLEAN_CHOICES],
        TO_INBOX: [...BOOLEAN_CHOICES],
        SYSTEM_MESSAGE: [...BOOLEAN_CHOICES],
    },
LANDING_ITEM: {
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'D', name: { key: 'deactive' } },
            { value: 'P', name: { key: 'pending' } },
        ],
        FROM: [
            { value: 'qrcode', name: 'qrcode' },
            { value: 'campaign_qrcode', name: 'campaign_qrcode' },
            { value: 'edm', name: 'edm' },
            { value: 'fb', name: 'fb' },
            { value: 'urlMap', name: 'urlMap' },
            { value: 'web', name: 'web' },
            { value: 'SPLASHAD', name: 'SPLASHAD' },
        ],
        WEB_TYPE: [
            { value: 'CAMPAIGN', name: 'CAMPAIGN' },
            { value: 'CLP', name: 'CLP' },
        ],
        FOLDER_TYPE: [{ value: 'CAMPAIGN', name: 'CAMPAIGN' }],
        QUERY: [
            { value: 'QUEUE', name: 'QUEUE' },
            { value: 'TAKEAWAY', name: 'TAKEAWAY' },
            { value: 'RESERVE', name: 'RESERVE' },
            { value: 'APPOINTMENT', name: 'APPOINTMENT' },
            { value: 'RACK_PRODUCT', name: 'RACK_PRODUCT' },
        ],
        SHOW_LIST: [
            { value: 'SHOW_CATEGORY_LIST', name: 'SHOW_CATEGORY_LIST' },
            { value: 'SHOW_BRAND_LIST', name: 'SHOW_BRAND_LIST' },
        ],
        SHARE_SERVICE_TYPE: [
            { value: 'QUEUE', name: 'QUEUE' },
            { value: 'RESERVE', name: 'RESERVE' },
            { value: 'APPOINTMENT', name: 'APPOINTMENT' },
            { value: 'TAKEAWAY', name: 'TAKEAWAY' },
            { value: 'ECOUPON', name: 'ECOUPON' },
        ],
    },
LANDING_SECTION: {
        CHANNEL: [
            { value: 'GLOBAL', name: 'GLOBAL' },
            { value: 'MOBILE', name: 'MOBILE' },
            { value: 'WECHAT_MP', name: 'WECHAT_MP' },
            { value: 'WEB', name: 'WEB' },
        ],
        MAIN_SECTION: [...BOOLEAN_CHOICES],
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'D', name: { key: 'deactive' } },
            { value: 'P', name: { key: 'pending' } },
        ],
        COPY_DATA_SOURCE: [
            { value: 'SHOP', name: 'SHOP' },
            { value: 'PRODUCT', name: 'PRODUCT' },
        ],
        ACTION_TYPE: [
            // { value: LANDING_SECTION_ACTION.WEB_VIEW, name: LANDING_SECTION_ACTION.WEB_VIEW },
            // { value: LANDING_SECTION_ACTION.LINK, name: LANDING_SECTION_ACTION.LINK },
            // { value: LANDING_SECTION_ACTION.VIDEO, name: LANDING_SECTION_ACTION.VIDEO },
            // { value: LANDING_SECTION_ACTION.PRODUCT, name: LANDING_SECTION_ACTION.PRODUCT },
            // { value: LANDING_SECTION_ACTION.PRODUCT_CATEGORY, name: LANDING_SECTION_ACTION.PRODUCT_CATEGORY },
            // { value: LANDING_SECTION_ACTION.PRODUCT_BRAND, name: LANDING_SECTION_ACTION.PRODUCT_BRAND },
            // { value: LANDING_SECTION_ACTION.E_COUPON, name: LANDING_SECTION_ACTION.E_COUPON },
            // { value: LANDING_SECTION_ACTION.E_COUPON_CATEGORY, name: LANDING_SECTION_ACTION.E_COUPON_CATEGORY },
            // { value: LANDING_SECTION_ACTION.E_COUPON_BRAND, name: LANDING_SECTION_ACTION.E_COUPON_BRAND },
            // { value: LANDING_SECTION_ACTION.COUPON, name: LANDING_SECTION_ACTION.COUPON },
            // //{ value: BANNER_ACTION.CATEGORY_PRODUCT, name: BANNER_ACTION.CATEGORY_PRODUCT },
            // //{ value: BANNER_ACTION.BRAND_PRODUCT, name: BANNER_ACTION.BRAND_PRODUCT },
            // { value: LANDING_SECTION_ACTION.FOLDER, name: LANDING_SECTION_ACTION.FOLDER },
            // { value: LANDING_SECTION_ACTION.RESTAURANT, name: LANDING_SECTION_ACTION.RESTAURANT },
            // { value: LANDING_SECTION_ACTION.SEARCH, name: LANDING_SECTION_ACTION.SEARCH },
            // { value: LANDING_SECTION_ACTION.ROTATING_BANNER, name: LANDING_SECTION_ACTION.ROTATING_BANNER },
            // { value: LANDING_SECTION_ACTION.RESTAURANT_CATEGORY, name: LANDING_SECTION_ACTION.RESTAURANT_CATEGORY },
            // { value: LANDING_SECTION_ACTION.SEARCH_NEAR_BY, name: LANDING_SECTION_ACTION.SEARCH_NEAR_BY },
            // { value: LANDING_SECTION_ACTION.MY_TICKET, name: LANDING_SECTION_ACTION.MY_TICKET },
            // { value: URL_MAP_ACTION.TRANSFORM_TICKET_FROM_PAPER, name: URL_MAP_ACTION.TRANSFORM_TICKET_FROM_PAPER },
            // { value: URL_MAP_ACTION.TRANSFORM_ECOUPON_FROM_PAPER, name: URL_MAP_ACTION.TRANSFORM_ECOUPON_FROM_PAPER },
            // { value: URL_MAP_ACTION.EXPRESS_TICKET_VOUCHER, name: URL_MAP_ACTION.EXPRESS_TICKET_VOUCHER },
            // { value: URL_MAP_ACTION.SHARE, name: URL_MAP_ACTION.SHARE },
            // { value: URL_MAP_ACTION.GIFT, name: URL_MAP_ACTION.GIFT },
            // //{ value: URL_MAP_ACTION.ECOUPON, name: URL_MAP_ACTION.ECOUPON },
            // { value: URL_MAP_ACTION.SCAN_QRCODE, name: URL_MAP_ACTION.SCAN_QRCODE },
            // { value: URL_MAP_ACTION.SPRINGBOARD, name: URL_MAP_ACTION.SPRINGBOARD },
            // { value: URL_MAP_ACTION.LANDING, name: URL_MAP_ACTION.LANDING },
            // { value: URL_MAP_ACTION.DOWNLOAD, name: URL_MAP_ACTION.DOWNLOAD },
            // {
            //   value: LANDING_SECTION_ACTION.SEARCH,
            //   name: LANDING_SECTION_ACTION.SEARCH,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.FOLDER,
            //   name: LANDING_SECTION_ACTION.FOLDER,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.RESTAURANT,
            //   name: LANDING_SECTION_ACTION.RESTAURANT,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.RESTAURANT_CATEGORY,
            //   name: LANDING_SECTION_ACTION.RESTAURANT_CATEGORY,
            // },
            // { value: LANDING_ACTION.PRODUCT, name: LANDING_SECTION_ACTION.PRODUCT },
            // {
            //   value: LANDING_SECTION_ACTION.COUPON,
            //   name: LANDING_SECTION_ACTION.COUPON,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.WEB_VIEW,
            //   name: LANDING_SECTION_ACTION.WEB_VIEW,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.HYPERLINK,
            //   name: LANDING_SECTION_ACTION.HYPERLINK,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.ROTATING_BANNER,
            //   name: LANDING_SECTION_ACTION.ROTATING_BANNER,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.SEARCH_SUGGESTION,
            //   name: LANDING_SECTION_ACTION.SEARCH_SUGGESTION,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.YOUTUBE,
            //   name: LANDING_SECTION_ACTION.YOUTUBE,
            // },
            {
                value: LANDING_SECTION_ACTION.HISTORICAL_SHOP,
                name: LANDING_SECTION_ACTION.HISTORICAL_SHOP,
            },
            {
                value: LANDING_ACTION_PARAMETER.WEB_VIEW,
                name: LANDING_ACTION_PARAMETER.WEB_VIEW,
            },
            { value: LANDING_ACTION_PARAMETER.LINK, name: LANDING_ACTION_PARAMETER.LINK },
            // { value: LANDING_ACTION_PARAMETER.VIDEO, name: LANDING_ACTION_PARAMETER.VIDEO },
            { value: LANDING_ACTION_PARAMETER.PRODUCT, name: LANDING_ACTION_PARAMETER.PRODUCT },
            {
                value: LANDING_ACTION_PARAMETER.PRODUCT_CATEGORY,
                name: LANDING_ACTION_PARAMETER.PRODUCT_CATEGORY,
            },
            {
                value: LANDING_ACTION_PARAMETER.PRODUCT_BRAND,
                name: LANDING_ACTION_PARAMETER.PRODUCT_BRAND,
            },
            {
                value: LANDING_ACTION_PARAMETER.E_COUPON,
                name: LANDING_ACTION_PARAMETER.E_COUPON,
            },
            {
                value: LANDING_ACTION_PARAMETER.E_COUPON_CATEGORY,
                name: LANDING_ACTION_PARAMETER.E_COUPON_CATEGORY,
            },
            {
                value: LANDING_ACTION_PARAMETER.E_COUPON_BRAND,
                name: LANDING_ACTION_PARAMETER.E_COUPON_BRAND,
            },
            //{ value: BANNER_ACTION.CATEGORY_PRODUCT, name: BANNER_ACTION.CATEGORY_PRODUCT },
            //{ value: BANNER_ACTION.BRAND_PRODUCT, name: BANNER_ACTION.BRAND_PRODUCT },
            { value: LANDING_ACTION_PARAMETER.FOLDER, name: LANDING_ACTION_PARAMETER.FOLDER },
            {
                value: LANDING_ACTION_PARAMETER.RESTAURANT,
                name: LANDING_ACTION_PARAMETER.RESTAURANT,
            },
            { value: LANDING_ACTION_PARAMETER.SEARCH, name: LANDING_ACTION_PARAMETER.SEARCH },
            { value: LANDING_ACTION_PARAMETER.YOUTUBE, name: LANDING_ACTION_PARAMETER.YOUTUBE },
            {
                value: LANDING_ACTION_PARAMETER.RESTAURANT_CATEGORY,
                name: LANDING_ACTION_PARAMETER.RESTAURANT_CATEGORY,
            },
            {
                value: LANDING_SECTION_ACTION.ROTATING_BANNER,
                name: LANDING_SECTION_ACTION.ROTATING_BANNER,
            },
        ],
        ITEM_ACTION_TYPE: [
            {
                value: LANDING_ACTION_PARAMETER.WEB_VIEW,
                name: LANDING_ACTION_PARAMETER.WEB_VIEW,
            },
            { value: LANDING_ACTION_PARAMETER.LINK, name: LANDING_ACTION_PARAMETER.LINK },
            // { value: LANDING_ACTION_PARAMETER.VIDEO, name: LANDING_ACTION_PARAMETER.VIDEO },
            { value: LANDING_ACTION_PARAMETER.PRODUCT, name: LANDING_ACTION_PARAMETER.PRODUCT },
            {
                value: LANDING_ACTION_PARAMETER.PRODUCT_CATEGORY,
                name: LANDING_ACTION_PARAMETER.PRODUCT_CATEGORY,
            },
            {
                value: LANDING_ACTION_PARAMETER.PRODUCT_BRAND,
                name: LANDING_ACTION_PARAMETER.PRODUCT_BRAND,
            },
            {
                value: LANDING_ACTION_PARAMETER.E_COUPON,
                name: LANDING_ACTION_PARAMETER.E_COUPON,
            },
            {
                value: LANDING_ACTION_PARAMETER.E_COUPON_CATEGORY,
                name: LANDING_ACTION_PARAMETER.E_COUPON_CATEGORY,
            },
            {
                value: LANDING_ACTION_PARAMETER.E_COUPON_BRAND,
                name: LANDING_ACTION_PARAMETER.E_COUPON_BRAND,
            },
            //{ value: BANNER_ACTION.CATEGORY_PRODUCT, name: BANNER_ACTION.CATEGORY_PRODUCT },
            //{ value: BANNER_ACTION.BRAND_PRODUCT, name: BANNER_ACTION.BRAND_PRODUCT },
            { value: LANDING_ACTION_PARAMETER.FOLDER, name: LANDING_ACTION_PARAMETER.FOLDER },
            {
                value: LANDING_ACTION_PARAMETER.RESTAURANT,
                name: LANDING_ACTION_PARAMETER.RESTAURANT,
            },
            { value: LANDING_ACTION_PARAMETER.SEARCH, name: LANDING_ACTION_PARAMETER.SEARCH },
            { value: LANDING_ACTION_PARAMETER.YOUTUBE, name: LANDING_ACTION_PARAMETER.YOUTUBE },
            {
                value: LANDING_ACTION_PARAMETER.RESTAURANT_CATEGORY,
                name: LANDING_ACTION_PARAMETER.RESTAURANT_CATEGORY,
            },
            // {
            //   value: LANDING_SECTION_ACTION.WEB_VIEW,
            //   name: LANDING_SECTION_ACTION.WEB_VIEW,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.LINK,
            //   name: LANDING_SECTION_ACTION.LINK,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.VIDEO,
            //   name: LANDING_SECTION_ACTION.VIDEO,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.PRODUCT,
            //   name: LANDING_SECTION_ACTION.PRODUCT,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.PRODUCT_CATEGORY,
            //   name: LANDING_SECTION_ACTION.PRODUCT_CATEGORY,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.PRODUCT_BRAND,
            //   name: LANDING_SECTION_ACTION.PRODUCT_BRAND,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.E_COUPON,
            //   name: LANDING_SECTION_ACTION.E_COUPON,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.E_COUPON_CATEGORY,
            //   name: LANDING_SECTION_ACTION.E_COUPON_CATEGORY,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.E_COUPON_BRAND,
            //   name: LANDING_SECTION_ACTION.E_COUPON_BRAND,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.COUPON,
            //   name: LANDING_SECTION_ACTION.COUPON,
            // },
            // //{ value: BANNER_ACTION.CATEGORY_PRODUCT, name: BANNER_ACTION.CATEGORY_PRODUCT },
            // //{ value: BANNER_ACTION.BRAND_PRODUCT, name: BANNER_ACTION.BRAND_PRODUCT },
            // {
            //   value: LANDING_SECTION_ACTION.FOLDER,
            //   name: LANDING_SECTION_ACTION.FOLDER,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.RESTAURANT,
            //   name: LANDING_SECTION_ACTION.RESTAURANT,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.SEARCH,
            //   name: LANDING_SECTION_ACTION.SEARCH,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.SEARCH_NEAR_BY,
            //   name: LANDING_SECTION_ACTION.SEARCH_NEAR_BY,
            // },
            // {
            //   value: LANDING_SECTION_ACTION.MY_TICKET,
            //   name: LANDING_SECTION_ACTION.MY_TICKET,
            // },
            // {
            //   value: URL_MAP_ACTION.TRANSFORM_TICKET_FROM_PAPER,
            //   name: URL_MAP_ACTION.TRANSFORM_TICKET_FROM_PAPER,
            // },
            // {
            //   value: URL_MAP_ACTION.TRANSFORM_ECOUPON_FROM_PAPER,
            //   name: URL_MAP_ACTION.TRANSFORM_ECOUPON_FROM_PAPER,
            // },
            // {
            //   value: URL_MAP_ACTION.EXPRESS_TICKET_VOUCHER,
            //   name: URL_MAP_ACTION.EXPRESS_TICKET_VOUCHER,
            // },
            // { value: URL_MAP_ACTION.SHARE, name: URL_MAP_ACTION.SHARE },
            // { value: URL_MAP_ACTION.GIFT, name: URL_MAP_ACTION.GIFT },
            // //{ value: URL_MAP_ACTION.ECOUPON, name: URL_MAP_ACTION.ECOUPON },
            // { value: URL_MAP_ACTION.SCAN_QRCODE, name: URL_MAP_ACTION.SCAN_QRCODE },
            // { value: URL_MAP_ACTION.SPRINGBOARD, name: URL_MAP_ACTION.SPRINGBOARD },
            // { value: URL_MAP_ACTION.LANDING, name: URL_MAP_ACTION.LANDING },
            // { value: URL_MAP_ACTION.DOWNLOAD, name: URL_MAP_ACTION.DOWNLOAD },
        ],
        LANDING_SECTION_SERVICE_TYPE: [
            {
                value: LANDING_SECTION_SERVICE_TYPE.EXPRESS_TICKET,
                name: LANDING_SECTION_SERVICE_TYPE.EXPRESS_TICKET,
            },
            {
                value: LANDING_SECTION_SERVICE_TYPE.QUEUE,
                name: LANDING_SECTION_SERVICE_TYPE.QUEUE,
            },
            {
                value: LANDING_SECTION_SERVICE_TYPE.TAKEAWAY,
                name: LANDING_SECTION_SERVICE_TYPE.TAKEAWAY,
            },
            {
                value: LANDING_SECTION_SERVICE_TYPE.RACK_PRODUCT,
                name: LANDING_SECTION_SERVICE_TYPE.RACK_PRODUCT,
            },
            {
                value: LANDING_SECTION_SERVICE_TYPE.RESERVE,
                name: LANDING_SECTION_SERVICE_TYPE.RESERVE,
            },
            {
                value: LANDING_SECTION_SERVICE_TYPE.APPOINTMENT,
                name: LANDING_SECTION_SERVICE_TYPE.APPOINTMENT,
            },
            {
                value: LANDING_SECTION_SERVICE_TYPE.ECOUPON,
                name: LANDING_SECTION_SERVICE_TYPE.ECOUPON,
            },
        ],
        LANDING_SECTION_SECTION_TYPE: [
            {
                value: LANDING_SECTION_SECTION_TYPE.HEADER_ITEMS,
                name: LANDING_SECTION_SECTION_TYPE.HEADER_ITEMS,
            },
            {
                value: LANDING_SECTION_SECTION_TYPE.ITEMS,
                name: LANDING_SECTION_SECTION_TYPE.ITEMS,
            },
            {
                value: LANDING_SECTION_SECTION_TYPE.ADS,
                name: LANDING_SECTION_SECTION_TYPE.ADS,
            },
            {
                value: LANDING_SECTION_SECTION_TYPE.SOCIAL_WALL,
                name: LANDING_SECTION_SECTION_TYPE.SOCIAL_WALL,
            }
        ],
        LANDING_ITEM_ITEM_TYPE: [
            { value: LANDING_ITEM_TYPE.IMAGE, name: LANDING_ITEM_TYPE.IMAGE },
            { value: LANDING_ITEM_TYPE.IMAGE_AD, name: LANDING_ITEM_TYPE.IMAGE_AD },
            { value: LANDING_ITEM_TYPE.IMAGE_TEXT, name: LANDING_ITEM_TYPE.IMAGE_TEXT },
            { value: LANDING_ITEM_TYPE.IMAGE_TEXT_AD, name: LANDING_ITEM_TYPE.IMAGE_TEXT_AD },

            {
                value: LANDING_ITEM_TYPE.TICKET_IMAGE,
                name: LANDING_ITEM_TYPE.TICKET_IMAGE,
            },
            {
                value: LANDING_ITEM_TYPE.TICKET_IMAGE_AD,
                name: LANDING_ITEM_TYPE.TICKET_IMAGE_AD,
            },
            {
                value: LANDING_ITEM_TYPE.TICKET_IMAGE_TEXT,
                name: LANDING_ITEM_TYPE.TICKET_IMAGE_TEXT,
            },
            {
                value: LANDING_ITEM_TYPE.TICKET_IMAGE_TEXT_AD,
                name: LANDING_ITEM_TYPE.TICKET_IMAGE_TEXT_AD,
            },

            {
                value: LANDING_ITEM_TYPE.SQUARE_ROUND_IMAGE,
                name: LANDING_ITEM_TYPE.SQUARE_ROUND_IMAGE,
            },
            {
                value: LANDING_ITEM_TYPE.SQUARE_ROUND_IMAGE_AD,
                name: LANDING_ITEM_TYPE.SQUARE_ROUND_IMAGE_AD,
            },

            {
                value: LANDING_ITEM_TYPE.LARGE_ROUND_IMAGE,
                name: LANDING_ITEM_TYPE.LARGE_ROUND_IMAGE,
            },
            {
                value: LANDING_ITEM_TYPE.LARGE_ROUND_IMAGE_AD,
                name: LANDING_ITEM_TYPE.LARGE_ROUND_IMAGE_AD,
            },
            {
                value: LANDING_ITEM_TYPE.LARGE_ROUND_IMAGE_TEXT,
                name: LANDING_ITEM_TYPE.LARGE_ROUND_IMAGE_TEXT,
            },
            {
                value: LANDING_ITEM_TYPE.LARGE_ROUND_IMAGE_TEXT_AD,
                name: LANDING_ITEM_TYPE.LARGE_ROUND_IMAGE_TEXT_AD,
            },

            { value: LANDING_ITEM_TYPE.PRODUCT, name: LANDING_ITEM_TYPE.PRODUCT },
            {
                value: LANDING_ITEM_TYPE.PRODUCT_LARGE,
                name: LANDING_ITEM_TYPE.PRODUCT_LARGE,
            },
            {
                value: LANDING_ITEM_TYPE.VALUE_UP_ECOUPON,
                name: LANDING_ITEM_TYPE.VALUE_UP_ECOUPON,
            },
            { value: LANDING_ITEM_TYPE.COUPON, name: LANDING_ITEM_TYPE.COUPON },
            {
                value: LANDING_ITEM_TYPE.BANNER_IMAGE,
                name: LANDING_ITEM_TYPE.BANNER_IMAGE,
            },
            {
                value: LANDING_ITEM_TYPE.RECOMMEND_BY_LOCATION,
                name: LANDING_ITEM_TYPE.RECOMMEND_BY_LOCATION,
            },
        ],
        QUERY: [
            { value: 'QUEUE', name: 'QUEUE' },
            { value: 'TAKEAWAY', name: 'TAKEAWAY' },
            { value: 'RESERVE', name: 'RESERVE' },
            { value: 'APPOINTMENT', name: 'APPOINTMENT' },
            { value: 'RACK_PRODUCT', name: 'RACK_PRODUCT' },
        ],
        MY_TICKET_SERVICE_TYPE: [
            { value: 'QUEUE', name: 'QUEUE' },
            { value: 'RESERVE', name: 'RESERVE' },
            { value: 'APPOINTMENT', name: 'APPOINTMENT' },
            { value: 'TAKEAWAY', name: 'TAKEAWAY' },
            { value: 'RACK_PRODUCT', name: 'RACK_PRODUCT' },
            { value: 'ECOUPON', name: 'ECOUPON' },
        ],
        MY_TICKET_RACK_PRODUCT_TYPE: [
            { value: 'ECOUPON', name: 'ECOUPON' },
            { value: 'ORDER', name: 'ORDER' },
        ],
        SHARE_SERVICE_TYPE: [
            { value: 'QUEUE', name: 'QUEUE' },
            { value: 'RESERVE', name: 'RESERVE' },
            { value: 'APPOINTMENT', name: 'APPOINTMENT' },
            { value: 'TAKEAWAY', name: 'TAKEAWAY' },
            { value: 'ECOUPON', name: 'ECOUPON' },
        ],
        GIFT_SERVICE_TYPE: [
            { value: 'RACK_PRODUCT', name: 'RACK_PRODUCT' },
            { value: 'ECOUPON', name: 'ECOUPON' },
        ],
        GIFT_RACK_PRODUCT_TYPE: [
            { value: 'ECOUPON', name: 'ECOUPON' },
            { value: 'ORDER', name: 'ORDER' },
        ],
    },
    BANNER: {
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'D', name: { key: 'deactive' } },
            { value: 'P', name: { key: 'pending' } },
        ],
        TYPE: [
            { value: BANNER_TYPE.FOLDER, name: BANNER_TYPE.FOLDER },
            { value: BANNER_TYPE.RESTAURANT, name: BANNER_TYPE.RESTAURANT },
            // { value: BANNER_TYPE.MERCHANT, name: BANNER_TYPE.MERCHANT },
            { value: BANNER_TYPE.MERCHANT_LOGIN, name: BANNER_TYPE.MERCHANT_LOGIN },
            {
                value: BANNER_TYPE.MERCHANT_LANDING,
                name: BANNER_TYPE.MERCHANT_LANDING,
            },
            // { value: BANNER_TYPE.RESTAURANT_TAG, name: BANNER_TYPE.RESTAURANT_TAG },
            { value: BANNER_TYPE.TICKET, name: BANNER_TYPE.TICKET },
            { value: BANNER_TYPE.LANDING_ALL, name: BANNER_TYPE.LANDING_ALL },
            { value: BANNER_TYPE.LANDING_MAIN, name: BANNER_TYPE.LANDING_MAIN },
            { value: BANNER_TYPE.LANDING_QUEUE, name: BANNER_TYPE.LANDING_QUEUE },
            {
                value: BANNER_TYPE.LANDING_TAKEAWAY,
                name: BANNER_TYPE.LANDING_TAKEAWAY,
            },
            {
                value: BANNER_TYPE.LANDING_RESERVATION,
                name: BANNER_TYPE.LANDING_RESERVATION,
            },
            {
                value: BANNER_TYPE.LANDING_APPOINTMENT,
                name: BANNER_TYPE.LANDING_APPOINTMENT,
            },
            {
                value: BANNER_TYPE.LANDING_BANQUET,
                name: BANNER_TYPE.LANDING_BANQUET,
            },
            {
                value: BANNER_TYPE.LANDING_RACK_PRODUCT,
                name: BANNER_TYPE.LANDING_RACK_PRODUCT,
            },
            {
                value: BANNER_TYPE.LANDING_ECOUPON,
                name: BANNER_TYPE.LANDING_ECOUPON,
            },
            // { value: BANNER_TYPE.EXPRESS_TICKET, name: BANNER_TYPE.EXPRESS_TICKET },
        ],
        LANDING_BANNER_TYPE: [
            { value: BANNER_TYPE.LANDING_ALL, name: BANNER_TYPE.LANDING_ALL },
            { value: BANNER_TYPE.LANDING_MAIN, name: BANNER_TYPE.LANDING_MAIN },
            { value: BANNER_TYPE.LANDING_QUEUE, name: BANNER_TYPE.LANDING_QUEUE },
            {
                value: BANNER_TYPE.LANDING_TAKEAWAY,
                name: BANNER_TYPE.LANDING_TAKEAWAY,
            },
            {
                value: BANNER_TYPE.LANDING_RESERVATION,
                name: BANNER_TYPE.LANDING_RESERVATION,
            },
            {
                value: BANNER_TYPE.LANDING_APPOINTMENT,
                name: BANNER_TYPE.LANDING_APPOINTMENT,
            },
            {
                value: BANNER_TYPE.LANDING_BANQUET,
                name: BANNER_TYPE.LANDING_BANQUET,
            },
            {
                value: BANNER_TYPE.LANDING_RACK_PRODUCT,
                name: BANNER_TYPE.LANDING_RACK_PRODUCT,
            },
            {
                value: BANNER_TYPE.LANDING_ECOUPON,
                name: BANNER_TYPE.LANDING_ECOUPON,
            },
        ],
        ACTION_TYPE: [
            { value: BANNER_ACTION.NONE, name: BANNER_ACTION.NONE },
            { value: BANNER_ACTION.DOWNLOAD, name: BANNER_ACTION.DOWNLOAD },
            { value: BANNER_ACTION.WEB_VIEW, name: BANNER_ACTION.WEB_VIEW },
            { value: BANNER_ACTION.LINK, name: BANNER_ACTION.LINK },
            // { value: BANNER_ACTION.PIXEL, name: BANNER_ACTION.PIXEL },
            { value: BANNER_ACTION.VIDEO, name: BANNER_ACTION.VIDEO },
            { value: BANNER_ACTION.PRODUCT, name: BANNER_ACTION.PRODUCT },
            {
                value: BANNER_ACTION.PRODUCT_CATEGORY,
                name: BANNER_ACTION.PRODUCT_CATEGORY,
            },
            {
                value: BANNER_ACTION.PRODUCT_BRAND,
                name: BANNER_ACTION.PRODUCT_BRAND,
            },
            { value: BANNER_ACTION.E_COUPON, name: BANNER_ACTION.E_COUPON },
            {
                value: BANNER_ACTION.E_COUPON_CATEGORY,
                name: BANNER_ACTION.E_COUPON_CATEGORY,
            },
            {
                value: BANNER_ACTION.E_COUPON_BRAND,
                name: BANNER_ACTION.E_COUPON_BRAND,
            },
            //{ value: BANNER_ACTION.CATEGORY_PRODUCT, name: BANNER_ACTION.CATEGORY_PRODUCT },
            //{ value: BANNER_ACTION.BRAND_PRODUCT, name: BANNER_ACTION.BRAND_PRODUCT },
            { value: BANNER_ACTION.FOLDER, name: BANNER_ACTION.FOLDER },
            { value: BANNER_ACTION.RESTAURANT, name: BANNER_ACTION.RESTAURANT },
            { value: BANNER_ACTION.SEARCH, name: BANNER_ACTION.SEARCH },
        ],
        MERCHANT_ACTION_TYPE: [
            { value: BANNER_ACTION.NONE, name: BANNER_ACTION.NONE },
            {
                value: BANNER_ACTION.MERCHANT_WEB_VIEW,
                name: BANNER_ACTION.WEB_VIEW,
            },
            { value: BANNER_ACTION.MERCHANT_LINK, name: BANNER_ACTION.LINK },
        ],
        PRODUCT_PARENT_TYPE: [
            {
                value: BANNER_PRODUCT_PARENT.BRAND,
                name: BANNER_PRODUCT_PARENT.BRAND,
            },
            {
                value: BANNER_PRODUCT_PARENT.CATEGORY,
                name: BANNER_PRODUCT_PARENT.CATEGORY,
            },
        ],
        HAVE_REF: [...BOOLEAN_CHOICES],
        FOLDER_TYPE: [{ value: 'CAMPAIGN', name: 'CAMPAIGN' }],
        QUERY: [
            { value: 'QUEUE', name: 'QUEUE' },
            { value: 'TAKEAWAY', name: 'TAKEAWAY' },
            { value: 'RESERVE', name: 'RESERVE' },
            { value: 'APPOINTMENT', name: 'APPOINTMENT' },
            { value: 'RACK_PRODUCT', name: 'RACK_PRODUCT' },
        ],
        RESTAURANT_ACTION: [
            { value: 'INFO', name: 'INFO' },
            { value: 'WALL', name: 'WALL' },
            { value: 'NEW_REVIEW', name: 'NEW_REVIEW' },
            { value: 'MENU', name: 'MENU' },
            { value: 'QUEUE', name: 'QUEUE' },
            { value: 'RESERVE', name: 'RESERVE' },
            { value: 'APPOINTMENT', name: 'APPOINTMENT' },
            { value: 'callback', name: 'APPOINTMENT_CALLBACK' },
            { value: 'appointmentContactShop', name: 'APPOINTMENT_CONTACT_SHOP' },
            { value: 'TAKEAWAY', name: 'TAKEAWAY' },
            { value: 'PICKUP', name: 'PICKUP' },
            { value: 'CALLING', name: 'CALLING' },
        ],
    },
    CONTACT_US: {
        TOPIC: [
            { value: 'GENERAL', name: 'GENERAL' },
            { value: 'FEEDBACKS', name: 'FEEDBACKS' },
            { value: 'PLANS', name: 'PLANS' },
            { value: 'ADVERTISING', name: 'ADVERTISING' },
            { value: 'LOGIN', name: 'LOGIN' },
            { value: 'SHOP_INFORMATION', name: 'SHOP_INFORMATION' },
            { value: 'SERVICE_ACTIVATION', name: 'SERVICE_ACTIVATION' },
            { value: 'LAUNCH_SHOP', name: 'LAUNCH_SHOP' },
            { value: 'PAYMENT', name: 'PAYMENT' },
            { value: 'TECHNICAL_PROBLEM', name: 'TECHNICAL_PROBLEM' },
            { value: 'USER_ACCOUNT', name: 'USER_ACCOUNT' },
            { value: 'APP_FUNCTION', name: 'APP_FUNCTION' },
            { value: 'RESTAURANT_REGISTRATION', name: 'RESTAURANT_REGISTRATION' },
            { value: 'ORDER', name: 'ORDER' },
            { value: 'REFUND', name: 'REFUND' },
            { value: 'MISSING_QRCODE', name: 'MISSING_QRCODE' },
        ],
        MESSAGE_TYPE: [
            {
                value: CONTACT_US_MESSAGE_TYPE.MOBILE,
                name: CONTACT_US_MESSAGE_TYPE.MOBILE,
            },
            {
                value: CONTACT_US_MESSAGE_TYPE.MERCHANT,
                name: CONTACT_US_MESSAGE_TYPE.MERCHANT,
            },
            {
                value: CONTACT_US_MESSAGE_TYPE.WEB,
                name: CONTACT_US_MESSAGE_TYPE.WEB,
            },
        ],
        STATUS: [
            { value: 'A', name: { key: 'active' } },
            { value: 'P', name: { key: 'processing' } },
            { value: 'C', name: { key: 'complete' } },
        ],
    },
}
